export const studyProgram = {
  "Joint Bachelor in Data Science": "Joint Bachelor in Data Science",
  "Master Data Science & Entrepreneurship":
    "Master Data Science & Entrepreneurship",
  "Master Data Science in Engineering": "Master Data Science in Engineering",
  "Master Data Science: Business and Governance":
    "Master Data Science: Business and Governance",
};
